export const MAX_ITEM_LIMIT = 10;